import React from 'react';

export const PainterTermsShort: React.FC = () => {
  return (
    <div className="space-y-4 text-sm text-gray-800 leading-relaxed">
      <div>
        <h3 className="font-semibold text-base mb-2">1. Eligibility</h3>
        <ul className="list-disc list-inside space-y-1 ml-2">
          <li>The program is open only to painters (individual or contractor) residing in India.</li>
          <li>Registration requires valid personal, KYC, and bank details. Incomplete forms may be rejected.</li>
        </ul>
      </div>

      <div>
        <h3 className="font-semibold text-base mb-2">2. Accuracy of Information</h3>
        <ul className="list-disc list-inside space-y-1 ml-2">
          <li>Painters must provide true, complete, and verifiable information.</li>
          <li>SCI Paints reserves the right to verify the details submitted. Any false or misleading information may lead to cancellation of membership and forfeiture of benefits.</li>
        </ul>
      </div>

      <div>
        <h3 className="font-semibold text-base mb-2">3. KYC & Verification</h3>
        <ul className="list-disc list-inside space-y-1 ml-2">
          <li>Aadhaar, PAN, and bank details provided will be used strictly for identification, verification, and payout purposes.</li>
          <li>SCI Paints may request additional documents for identity or address verification when required.</li>
        </ul>
      </div>

      <div>
        <h3 className="font-semibold text-base mb-2">4. Bank Details & Payments</h3>
        <ul className="list-disc list-inside space-y-1 ml-2">
          <li>Rewards and payouts will be transferred only to the registered bank account.</li>
          <li>SCI Paints will not be responsible for delays or failed transactions due to incorrect bank details provided by the painter.</li>
        </ul>
      </div>

      <div>
        <h3 className="font-semibold text-base mb-2">5. Loyalty Program Benefits</h3>
        <ul className="list-disc list-inside space-y-1 ml-2">
          <li>Painters can earn points/rewards through valid coupon/token scanning and other program activities as communicated by SCI Paints.</li>
          <li>Points and benefits are non-transferable, non-refundable, and cannot be exchanged for cash except as per program rules.</li>
        </ul>
      </div>

      <div>
        <h3 className="font-semibold text-base mb-2">6. Usage of Data</h3>
        <ul className="list-disc list-inside space-y-1 ml-2">
          <li>By registering, the painter authorizes SCI Paints to use the submitted information for program management, communication, and promotional purposes.</li>
          <li>Data will be stored securely and will not be shared with third parties, except as required for payouts or by law.</li>
        </ul>
      </div>

      <div>
        <h3 className="font-semibold text-base mb-2">7. Termination & Suspension</h3>
        <ul className="list-disc list-inside space-y-1 ml-2">
          <li>SCI Paints reserves the right to suspend or terminate any membership if fraudulent activity, misuse of coupons, or violation of program rules is detected.</li>
          <li>SCI Paints also reserves the right to modify, withdraw, or discontinue the program at any time without prior notice.</li>
        </ul>
      </div>

      <div>
        <h3 className="font-semibold text-base mb-2">8. Service Charges</h3>
        <ul className="list-disc list-inside space-y-1 ml-2">
          <li>A small percentage will be deducted from every transaction as service/processing/maintenance charges.</li>
          <li>These charges are non-refundable.</li>
        </ul>
      </div>

      <div>
        <h3 className="font-semibold text-base mb-2">9. Disputes</h3>
        <ul className="list-disc list-inside space-y-1 ml-2">
          <li>In case of disputes regarding rewards, points, or payouts, the decision of SCI Paints management will be final and binding.</li>
          <li>All disputes are subject to jurisdiction of Serampore, West Bengal.</li>
        </ul>
      </div>
    </div>
  );
};

